// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".transfer-comment-notification-modal .transfer-comment-content .comment-body{padding:4px 8px;border-radius:5px;margin-bottom:12px}.light-theme .transfer-comment-notification-modal .transfer-comment-content .comment-body{border:1px solid #e8ebec}.dark-theme .transfer-comment-notification-modal .transfer-comment-content .comment-body{border:1px solid #363a3d}", ""]);
// Exports
module.exports = exports;
